import React from 'react';
import { X } from 'lucide-react';

interface MiniModalProps {
  visible: boolean;
  title: string;
  footer?: React.ReactNode;
  children: React.ReactNode;
}

export function MiniModal({ visible, title, footer, children }: MiniModalProps) {
  return (
    <div className={`absolute inset-0 z-30 flex items-center justify-center transition-opacity duration-500 ${visible ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
      <div className="absolute inset-0 bg-overlay-scrim" />
      <div className="relative bg-surface-panel rounded-panel shadow-modal w-[55%] max-w-[320px] max-h-[75%] overflow-hidden flex flex-col">
        <div className="flex items-center justify-between px-3 py-2 shrink-0">
          <div className="text-[9px] font-[var(--fw-medium)] text-text-primary">{title}</div>
          <X size={10} className="text-text-quaternary shrink-0" />
        </div>
        <div className="px-3 pb-2 overflow-y-auto hide-scrollbar flex-1">{children}</div>
        {footer && (
          <div className="px-3 py-2 border-t border-border-subtle shrink-0">{footer}</div>
        )}
      </div>
    </div>
  );
}
